import * as yup from "yup";
import { BUSINESS_NUMBER_ERROR, HOMEPAGE_ERROR, isValidBusinessNumber, isValidHomepage } from "@/utils/clinicFields";

export const SignUpValidate = yup.object({
  password: yup.string()
    .min(3, '비밀번호는 최소 3자 이상이어야 합니다')
    .required('비밀번호는 필수 항목입니다'),
  name: yup.string()
    .min(2, '이름은 최소 2자 이상이어야 합니다')
    .required('이름은 필수 항목입니다'),
  nickName: yup.string()
    .min(2, '닉네임은 최소 2자 이상이어야 합니다')
    .required('닉네임은 필수 항목입니다'),
  // [APPSTORE-5.1.1(v) 임시 완화] 생년월일·전화번호·주소(+성별)를 선택 입력으로 완화 — Apple 심사 거부(핵심 기능과 무관한 개인정보 필수 요구) 대응.
  //   심사 통과 후 웹·Android 는 다시 필수로 되돌릴 예정(iOS 앱은 isIosApp() 분기로 선택 유지 필요). 되돌릴 때 검색어: APPSTORE-5.1.1(v) 임시 완화
  //   이전 값: birthday .required('생년월일은 필수 항목입니다') / phone .length(11).required(...) / address·detailAddress .required(...) / subwayStation .required(...)
  birthday: yup.string(),
  userType: yup.string().required('회원구분은 필수 항목입니다'),
  // 2026-09-27 전화번호는 다시 필수(앱 심사 통과 후 사용자 결정 — 연락처 미입력이 많아서). 생년월일·주소는 선택 유지
  phone: yup.string()
    .required('전화번호는 필수 항목입니다')
    .matches(/^(010\d{8}|01[16789]\d{7,8})$/, '휴대폰 번호를 숫자만 정확히 입력해 주세요(010은 11자리)'),
  email: yup.string()
    .email('올바른 이메일 형식이 아닙니다')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, '올바른 이메일 형식이 아닙니다')
    .required('이메일은 필수 항목입니다'),
  address: yup.string(),
  detailAddress: yup.string(),
  careerYear: yup.number(),
  workingClinicName: yup.string(),
  licenseNumber: yup.string(),
  subwayStation: yup.array().of(yup.string()),
});

export const DentalSignUpValidate = yup.object({
  email: yup.string().email('올바른 이메일 형식이 아닙니다').matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, '올바른 이메일 형식이 아닙니다').required('이메일은 필수 항목입니다.'),
  password: yup.string().required('비밀번호는 필수 항목입니다.'),
  hospitalName: yup.string().required('치과 이름은 필수 항목입니다.'),
  hospitalType: yup.string().required('치과 구분은 필수 항목입니다.'),
  address: yup.string().required('주소는 필수 항목입니다.'),
  detailAddress: yup.string().required('상세 주소는 필수 항목입니다.'),
  since: yup.string().required('개업 연도는 필수 항목입니다.'),
  ownerName: yup.string().required('대표자 이름은 필수 항목입니다.'),
  hospitalTel: yup.string().required('치과 전화번호는 필수 항목입니다.'),
  // 2026-10-10 사업자등록번호·치과 홈페이지 필수(자동 승인 — 홈페이지에 적힌 대표자·사업자 번호·주소로 검증)
  // 2026-10-10 가입은 홈페이지를 받지 않아도 된다(병원 인증 단계에서 확인) — 적었으면 형식만
  url: yup.string().test('homepage', HOMEPAGE_ERROR, (value) => !value || isValidHomepage(value)),
  thumbnailImage: yup.string(),
  licenseNumber: yup.string().required('사업자등록번호는 필수 항목입니다.').test('business-number', BUSINESS_NUMBER_ERROR, (value) => !value || isValidBusinessNumber(value)),
  hospitalDescription: yup.string(),
  employeeDescription: yup.string(),
  subwayStation: yup.array().of(yup.string()),
  recruitmentManagerName: yup.string().required('채용 담당자 이름은 필수 항목입니다.'),
  recruitmentManagerEmail: yup.string().email('올바른 이메일 형식이 아닙니다').matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, '올바른 이메일 형식이 아닙니다').required('담당자 이메일은 필수 항목입니다.'),
  recruitmentManagerTel: yup.string().required('채용 담당자 전화번호는 필수 항목입니다.'),
});

export const SignInValidate = yup.object({
  email: yup.string()
    .email('올바른 이메일 형식이 아닙니다')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, '올바른 이메일 형식이 아닙니다')
    .required('이메일을 입력해주세요'),
  password: yup.string().required(),
});

export const ClinicEditValidate = yup.object().shape({
	name: yup.string().required('병원명을 입력하세요'),
	ownerName: yup.string().required('대표자명을 입력하세요'),
	phoneNumber: yup.string().required('전화번호를 입력하세요'),
	managerName: yup.string().required('관리자명을 입력하세요'),
	managerEmail: yup.string().email('유효한 이메일을 입력하세요').required('이메일을 입력하세요'),
	managerPhoneNumber: yup.string().required('전화번호를 입력하세요'),
	description: yup.string().required('설명을 입력하세요'),
	totalWorkers: yup
	    .number()
	    .required('직원 수를 입력하세요')
	    .min(1, '최소 1명의 직원이 필요합니다'),
	totalWorkersDescription: yup.string().required('직원 설명을 입력하세요'),
	address: yup.string().required('주소를 입력하세요'),
	addressDetail: yup.string().required('상세 주소를 입력하세요'),
	stations: yup
	    .array()
	    .of(yup.string())
	    .min(1, '최소 하나 이상의 지하철 역을 선택하세요')
	    .required('지하철 역을 선택하세요'),
	url: yup.string().required('웹사이트 URL을 입력하세요'),
	thumbnail: yup
	    .string()
	//     .url('유효한 썸네일 URL을 입력하세요')
	    .required('썸네일 URL을 입력하세요'),
    });
    



